import { FormikSelect } from '@/components/forms';
import { SelectItem } from '@/design-system/components/ui';

import { FilterMeetCondition } from '../domain';

export const TriggerConditionMeetTypeSelector = () => {
  return (
    <FormikSelect name="filterMeetCondition" className="tw:w-20">
      <SelectItem value={FilterMeetCondition.ANY}>{FilterMeetCondition.ANY}</SelectItem>
      <SelectItem value={FilterMeetCondition.ALL}>{FilterMeetCondition.ALL}</SelectItem>
    </FormikSelect>
  );
};
